import React from "react";
import { Col } from "react-bootstrap";
import { Field } from "redux-form";
import { AutoCompleteField } from "MODULES/shared/components/Forms";
import T from "prop-types";
import { searchRoleUsers } from "MODULES/users/actions";
import {
  SALES,
  TEAM_LEADER_CREDIT_PERCENT,
  USER_ID
} from "MODULES/users/constants";
import NumberInput from "MODULES/shared/components/Forms/NumberInput/NumberInput";

export default function TeamMembers({ fields, teamMembers }) {
  return (
    <div>
      {fields.map((field, index) => {
        const teamMember = teamMembers[index];
        return (
          <div key={`team-member-${field + index}`}>
            <div className="row">
              <Col md={4}>
                <Field
                  name={`${field}.${USER_ID}`}
                  label="Seller"
                  placeholder="Type a user's name..."
                  component={AutoCompleteField}
                  search={searchRoleUsers([SALES])}
                  formatItem={result => result && result.full_name}
                  selectedItem={teamMember}
                  required
                />
              </Col>
              <Col md={5}>
                <Field
                  name={`${field}.${TEAM_LEADER_CREDIT_PERCENT}`}
                  component={NumberInput}
                  roundDigits={1}
                  required
                  label="Commission Percent"
                />
              </Col>
              <Col md={2}>
                <button
                  type="button"
                  className="btn btn-xs btn-default btn-hollow"
                  style={{ marginTop: 10 }}
                  onClick={() => fields.remove(index)}
                >
                  <i className="fa fa-fw fa-ban" /> &nbsp;Remove
                </button>
              </Col>
            </div>
          </div>
        );
      })}
      <button
        type="button"
        onClick={() => fields.push({})}
        className="btn btn-primary btn-hollow"
        style={{ marginTop: 5, marginBottom: 15 }}
      >
        <i className="fa fa-fw fa-plus" /> Add Team Member
      </button>
    </div>
  );
}

TeamMembers.defaultProps = {
  fields: []
};

TeamMembers.propTypes = {
  fields: T.shape({
    length: T.number,
    push: T.func
  })
};



// WEBPACK FOOTER //
// ./app/modules/users/components/Admin/TeamMembers.jsx